export const iconFontAwesomeWritingPaperPlane = (
	<i className="fa-solid fa-paper-plane"></i>
);
